// components/Avatar.jsx
import React from "react";
import { useUserAvatar } from "../hooks/useUserAvatar";

export default function Avatar({ userId, size = 40, className = "" }) {
  const url = useUserAvatar(userId);

  return (
    <img
      src={url}
      alt="Avatar"
      className={className}
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        objectFit: "cover",
      }}
    />
  );
}
